<template>
  <div class="flex-box editor-area-inside" :class="{'sider-state': !openState}">
    <div class="left flex-box-left">
      <div class="sider-inside" @click="handleChangeState">
        <i class="open" v-if="openState" />
        <i class="collect" v-if="!openState" />
      </div>
      <!--活动面板-->
      <splitpanes class="default-theme" horizontal="horizontal">
        <pane class="left-top" :size="paneSize">
          <EditorMain :editorMode="editorMode" />
        </pane>
        <pane class="editor-bottom-pane" min-size="5" :size="100 - paneSize " max-size="50">
          <EditorBottom />
        </pane>
      </splitpanes>
    </div>
    <div class="right right-top flex-box-right">
      <EditorRight />
    </div>
  </div>
</template>

<script>
import EditorMain from "./modules/editor";
import { Splitpanes, Pane } from "splitpanes";
import EditorRight from "./modules/editorRight";
import EditorBottom from "./modules/editorBottom";
import { eventUtil } from "@/components/editor/modules/eventUtil";
// import ContentediTopComparison from "./modules/editor/modules/contentediTopComparison";
// import ContentediLeftComparison from "./modules/editor/modules/contentediLeftComparison"
import "splitpanes/dist/splitpanes.css";
export default {
  name: "EditorArea",
  props: ["editorMode"],
  components: { EditorRight, EditorMain, EditorBottom, Splitpanes, Pane },
  data() {
    return {
      paneSize: 80,
      openState: true,
    };
  },
  mounted() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  computed: {
    //获取编辑模式
    // getComparisonMode () {
    //   return this.$store.getters["editor/getComparisonMode"]
    // },
  },
  destroyed() {
    document.removeEventListener("keydown", this.handleKeydown);
  },

  methods: {
    handleKeydown(e) {
      if (e.ctrlKey && e.keyCode === 77) {
        eventUtil.preventDefault(e);
        this.openState = !this.openState;
      }
      // if (e.ctrlKey && e.keyCode === 81) {
      //   eventUtil.preventDefault(e);
      //   let params = Object();
      //   Reflect.set(params, "column", "second");
      //   Reflect.set(params, "sourceKeyword", null);
      //   Reflect.set(params, "targetKeyword", null);
      //   this.$store.dispatch("editor/setOerationSignInfo", params);
      // }
    },

    //右侧收齐和展开控制状态
    handleChangeState() {
      this.openState = !this.openState;
    }
  }
};
</script>

<style lang="less" scoped>
@import "./assets/style.less";
</style>